import React from "react";
import { useTranslate } from "ra-core";
import { Alert } from '@material-ui/lab';

const MissingResourceAlert = () => {
    const translate = useTranslate();
    return (
        <Alert severity="error">{translate(`cmss.resources.the-resource-that-you-are-trying-to-find-is-missing`)}</Alert>
    );
}

export default MissingResourceAlert;